document.addEventListener("DOMContentLoaded", function () {
  // Select all elements with the class 'wpcf7-form-control' but exclude those with type="tel"
  const formControls = document.querySelectorAll(
    ".wpcf7-form-control:not([type='tel'])"
  );
  formControls.forEach(function (control) {
    control.required = true;
  });

  // Select all elements with the class 'wpcf7-form' and remove the 'novalidate' attribute
  const forms = document.querySelectorAll(".wpcf7-form");
  forms.forEach(function (form) {
    form.removeAttribute("novalidate");
  });
});
